
window.fetch = new Proxy(window.fetch, {
  apply(original, thisArg, [url, config]) {
    if (url.includes('/cart/change')) {
    }
    return Reflect.apply(original, thisArg, [url, config]).then(async (res) => {
      if (url.includes('/cart/change')) {
        const clone = res.clone();
        const data = await clone.text();
      }
      return res;
    });
  }
});

const cartObserver = new MutationObserver((mutations) => {
  let shouldReinit = false;

  for (const mutation of mutations) {
    if (
      mutation.type === 'childList' &&
      (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
    ) {
      const hasCartElement = Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 && // Element node
          (node.tagName === 'CART-DRAWER-ITEMS' ||
            node.tagName === 'CART-ITEMS' ||
            node.querySelector?.('cart-drawer-items, cart-items'))
      );

      if (hasCartElement) {
        shouldReinit = true;
        break;
      }
    }
  }

  if (shouldReinit) {
    clearTimeout(cartObserver.reinitTimeout);
    cartObserver.reinitTimeout = setTimeout(() => {
      reinitializeCartItems();
    }, 100);
  }
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('keydown', (e) => this.onKeyDown(e));
    this.querySelector('.cart-drawer__overlay')?.addEventListener('click', () => this.close());
    this.querySelectorAll('.drawer__close').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('page-blurred');
    this.querySelector('.cart-drawer__inner')?.focus();
    
    // Wait for the drawer animation + DOM to settle
    setTimeout(() => {
      document.querySelectorAll('cart-drawer-items').forEach(el => {
        if (!(el instanceof CartItems)) {
          customElements.upgrade(el);
          Object.setPrototypeOf(el, CartItems.prototype);
        }
      });
      reinitializeCartItems();
    }, 300);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('page-blurred');
  }

  onKeyDown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

// CartRemoveButton - handles remove button clicks
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else {
      }
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    // Remove old listener if exists
    if (this.debouncedOnChange) {
      this.removeEventListener('change', this.debouncedOnChange);
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
  return [
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '.drawer__inner'
    },
    {
      id: 'cart-notification',
      section: 'cart-notification',
      selector: '.cart-notification'
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}
  
  updateQuantity(line, quantity) {
  this.enableLoading(line);

  const sectionsToRender = this.getSectionsToRender();
  const cartItem = this.querySelector(`[data-index="${line}"]`);

  // ✅ Get variant ID directly
  const variantId = cartItem?.dataset?.variantId;
  if (!variantId) {
    this.disableLoading();
    return;
  }

  const body = JSON.stringify({
  line: parseInt(line),
  quantity: parseInt(quantity),
  sections: sectionsToRender.map((s) => s.section),
  sections_url: window.location.pathname,
});



  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      // Format price with currency symbol and code
      const formatPrice = (price) => {
        if (!price) return '';
        
        // Get the store's currency symbol and code from the cart drawer
        const priceElement = document.querySelector('.totals__subtotal-value');
        const priceText = priceElement?.textContent?.trim() || '';
        
        // Extract currency symbol (e.g., £, $) and code (e.g., GBP, USD)
        const currencySymbol = priceText.match(/^[^\d\s.,]+/)?.[0] || '£';
        const currencyCode = (() => {
          // Try to get from existing price text (e.g., "£10.00 GBP")
          const codeMatch = priceText.match(/([A-Z]{3})$/);
          if (codeMatch) return codeMatch[1];
          
          // Fallback to common currency codes based on symbol
          const symbolToCode = {
            '£': 'GBP',
            '$': 'USD',
            '€': 'EUR',
            '¥': 'JPY',
            '₹': 'INR',
            'A$': 'AUD',
            'CA$': 'CAD'
          };
          return symbolToCode[currencySymbol] || '';
        })();
        
        // Format the number with 2 decimal places and thousands separators
        const formattedValue = (price / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        
        // Return formatted price with both symbol and code (e.g., "£10.00 GBP")
        return `${currencySymbol}${formattedValue} ${currencyCode}`.trim();
      };

      // Update prices from the response
      if (parsedState.items && parsedState.items[line]) {
        const item = parsedState.items[line];
        const lineItem = this.querySelector(`[data-index="${line}"]`);
        if (lineItem) {
          // Update line item price
          const priceElement = lineItem.querySelector('.cart-item__price, .cart-item__price .price');
          if (priceElement && item.final_line_price) {
            priceElement.textContent = formatPrice(item.final_line_price);
          }
          
          // Update unit price if it exists
          const unitPriceElement = lineItem.querySelector('.cart-item__price--unit');
          if (unitPriceElement && item.final_price) {
            unitPriceElement.textContent = formatPrice(item.final_price);
          }
        }
      }

      // Update cart total
      const cartTotalElement = document.querySelector('.totals__subtotal-value, .cart-totals__total .cart-item__price');
      if (cartTotalElement && parsedState.original_total_price) {
        cartTotalElement.textContent = formatPrice(parsedState.original_total_price);
      }

      // 🔄 Replace all rendered sections
      sectionsToRender.forEach((section) => {
        const html = parsedState.sections?.[section.section];
        const target =
          document.getElementById(section.id)?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (html && target) {
          const newInner = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(section.selector)?.innerHTML;
          if (newInner) target.innerHTML = newInner;
        }
      });

      reinitializeCartItems();
      this.updateLiveRegions(line, parsedState.item_count);
      this.disableLoading();
    })
    .catch((err) => {
      this.querySelectorAll('.loading-overlay').forEach((o) => o.classList.add('hidden'));
      this.disableLoading();
    });
}


  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`CartDrawer-Quantity-${line}`);

      if (lineItemError && quantityElement) {
        lineItemError.querySelector('.cart-item__error-text').innerHTML =
          window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement?.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    );

    document.activeElement?.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.remove('cart__items--disabled');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartItems);
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, 300)
        );
      }
    }
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function reinitializeCartItems() {
  const elements = document.querySelectorAll('cart-items, cart-drawer-items');

  elements.forEach((el) => {

    // CRITICAL: If NOT an instance, we need to manually make it one
    if (!(el instanceof CartItems)) {
      
      // Set the prototype to CartItems
      Object.setPrototypeOf(el, CartItems.prototype);
      
      // Now call init to set up all listeners
      if (typeof el.init === 'function') {
        el.init();
      }
    } else {
      // If it IS already an instance, just reinit
      el.init();
    }
  });

  // Re-bind quantity buttons
  const buttons = document.querySelectorAll('.quantity__button');

  buttons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const input = this.closest('quantity-input').querySelector('input');
      const previousValue = parseInt(input.value);

      if (this.name === 'plus') {
        input.value = previousValue + 1;
      } else if (this.name === 'minus' && previousValue > 0) {
        input.value = previousValue - 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

}

// Start observing for cart mutations when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    debugSectionIds();
    startCartObserver();
    // Delay to ensure cart drawer is in DOM
    setTimeout(() => {
      reinitializeCartItems();
    }, 200);
  });
} else {
  debugSectionIds();
  startCartObserver();
  // Delay to ensure cart drawer is in DOM
  setTimeout(() => {
    reinitializeCartItems();
  }, 200);
}

// 🧩 Step 2: Debug available section IDs
function debugSectionIds() {
  const sectionsWithIds = document.querySelectorAll('[data-section-id]');
  sectionsWithIds.forEach(el => {
  });
  


function startCartObserver() {
  const cartContainer =
    document.getElementById('main-cart-items') ||
    document.getElementById('CartDrawer-CartItems') ||
    document.querySelector('cart-drawer-items') ||
    document.querySelector('cart-items');

  if (cartContainer) {
    cartObserver.observe(cartContainer.parentElement, {
      childList: true,
      subtree: true,
    });
  } else {
    console.warn('⚠️ No cart container found for observer');
  }
}

}